import { FormEventHandler } from "react"
import PasswordChangeView from "./PasswordChangeView"
import { useChangePasswordAction } from "./api/action"

const PasswordChangeViewContainer = ({
  onContinue,
  onCancel,
  showHeading
}: {
  onContinue: Function
  onCancel?: Function
  showHeading?: boolean
}) => {
  const [state, action] = useChangePasswordAction()

  const handleSubmit: FormEventHandler<HTMLFormElement> = async (e) => {
    e.preventDefault()
    const formData = new FormData(e.currentTarget)
    await action(formData)
  }

  return (
    <PasswordChangeView
      data={state.value}
      loading={state.loading}
      success={!!state.value}
      error={state.error?.message}
      onSubmit={handleSubmit}
      onContinue={onContinue}
      onCancel={onCancel}
      showHeading={showHeading}
    />
  )
}

export default PasswordChangeViewContainer
